import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-per",
  "use": "icon-icon-per-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-per\"><!--Generator: Adobe Illustrator 29.0.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 186)--><rect x=\"267.51\" y=\"63.95\" width=\"488.98\" height=\"488.98\" rx=\"224.7\" ry=\"224.7\" /><path d=\"M834.23,958.18c121.03,0,171.91-160.48,75.12-236.23-106.4-83.26-245.27-123.79-397.18-123.79s-291.87,40.91-398.43,124.76c-95.99,75.52-43.9,235.26,76.34,235.26h644.16-.01Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol